import React, { useEffect, useState } from "react";
import Modal from "../../components/Modal/Modal";
import "./RepositoryList.css";

interface Repository {
  id: number;
  name: string;
  description: string;
  language: string;
  forks: number;
  created_at: string;
  owner: {
    login: string;
  };
}
interface Commit {
  commit: {
    author: {
      name: string;
      date: string;
    };
    message: string;
  };
}

interface RepositoryListProps {
  languages: string[];
  repositories: Repository[];
}

const RepositoryList: React.FC<RepositoryListProps> = ({
  languages,
  repositories,
}) => {
  const [filterLanguage, setFilterLanguage] = useState<string>("All");
  const [filterRepositories, setFilterRepositories] =
    useState<Repository[]>(repositories);
  const [commit, setCommit] = useState<Commit | null>(null);
  const [displayCommit, setDisplayCommit] = useState<boolean>(false);

  const handleFilterLanguage = (language: string) => {
    if (language === "All") {
      setFilterRepositories(repositories);
    } else {
      setFilterRepositories(
        repositories.filter((repo) => repo.language === language)
      );
    }
    setFilterLanguage(language);
  };

  const handleDisplayCommit = (repo: Repository) => {
    fetch("https://welast-node-express.vercel.app/commit", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ repo: repo.name, owner: repo.owner.login }),
    })
      .then((response) => response.json())
      .then((data) => {
        const recentCommit = data.reduce((a: Commit, b: Commit) =>
          a.commit.author.date > b.commit.author.date ? a : b
        );
        setCommit(recentCommit);
        setDisplayCommit(true);
      })
      .catch((error) => alert("API rate limit exceeded, please wait"));
  };
  const handleCloseCommit = () => {
    setCommit(null);
    setDisplayCommit(false);
  };
  useEffect(() => {
    repositories
      .sort((a, b) => +new Date(a.created_at) - +new Date(b.created_at))
      .reverse();
    setFilterRepositories(repositories);
  }, [repositories]);

  return (
    <div className="RepositoryList">
      <Modal display={displayCommit} onClose={handleCloseCommit}>
        <>
          <h1>
            Date: <span>{commit?.commit.author.date}</span>
          </h1>
          <h2>
            Name: <span>{commit?.commit.author.name}</span>
          </h2>
          <h3>
            Message: <span>{commit?.commit.message} </span>
          </h3>
        </>
      </Modal>
      <div className="filter-lang">
        {languages.map((lang: string, idx) => (
          <button key={idx} onClick={() => handleFilterLanguage(lang)}>
            {lang}
          </button>
        ))}
      </div>
      <h2>Filter by:</h2>
      <h2> {filterLanguage}</h2>
      <table>
        <tbody>
          <tr>
            <th>Name</th>
            <th>Description</th>
            <th>Language</th>
            <th>Forks</th>
            <th>Created At</th>
          </tr>
          {filterRepositories.map((repo: Repository) => (
            <tr
              onClick={() => handleDisplayCommit(repo)}
              className="repo-details"
              key={repo.id}
            >
              <td>{repo.name}</td>
              <td>{repo.description ? repo.description : "Nothing"}</td>
              <td>{repo.language ? repo.language : "Not language"}</td>
              <td>{repo.forks}</td>
              <td>{repo.created_at}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RepositoryList;
